import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/**
 * A homeware shop's product page: the picture square, and the colourway beside
 * it.
 *
 * Square rather than portrait, because everything in this shop is photographed
 * cut out on white and a portrait frame around a frying pan is two-thirds
 * empty. The thumbnails stand under the picture rather than in a rail: they are
 * the *other colours*, not other angles, and a row of them reads as a set to
 * choose from where a vertical strip reads as a filmstrip.
 *
 * The buy column stays put while the description runs on, which is what keeps
 * "add to cart" reachable on a page whose prose is three paragraphs about a
 * glaze.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-12 py-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:gap-20">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-28 lg:self-start" />
  </StorefrontContainer>
);
